<app-toast />

<section class="anuidade-detalhe">
    <div class="anuidade-detalhe-inner">
        <div class="anuidade-detalhe-layout">
            <!-- ═══════════════════════════════════════════
                 COLUNA ESQUERDA — Configuração (sticky)
            ═══════════════════════════════════════════ -->
            <div class="coluna-config">
                <!-- ─ Identidade ─ -->
                <app-card-content [border]="false" [headerColor]="false" [title]="modoNovo() ? 'Novo Tipo de Débito' : 'Configuração de Débito'" [subtitle]="'Manutenção de anuidades, taxas e multas'" [icon]="'pi pi-money-bill'">
                    <p-button label="Voltar" icon="pi pi-arrow-left" styleClass="p-button-outlined" [size]="'small'" (click)="voltar()" card-header />

                    <div class="flex items-center justify-between gap-2">
                        <div class="flex items-center gap-2 min-w-0">
                            @if (!modoNovo()) {
                                <p-badge [value]="codigo()" badgeSize="large" severity="secondary" />
                            }
                            @if (sgUf()) {
                                <p-tag [value]="sgUf()" severity="info" styleClass="text-[11px]" />
                            }
                        </div>
                        <div class="flex justify-end gap-2 flex-shrink-0">
                            @if (editando()) {
                                <p-button label="Cancelar" icon="pi pi-times" [text]="true" severity="secondary" (click)="cancelar()" />
                                <p-button label="Salvar" icon="pi pi-check" severity="primary" [loading]="salvando()" (click)="salvar()" [appCan]="roleAnuidadesEditar" />
                            } @else {
                                <p-button label="Editar" icon="pi pi-pencil" severity="primary" (click)="editar()" [appCan]="roleAnuidadesEditar" />
                            }
                        </div>
                    </div>
                </app-card-content>

                <!-- ─ Parâmetros ─ -->
                <div class="card-entrada card-entrada-1">
                    <app-card-content [border]="false" [headerColor]="false" [title]="'Definição do Débito'" [subtitle]="'Identificação do débito'" [icon]="'pi pi-sliders-h'">
                        <div class="flex flex-col gap-4">
                            <div class="field">
                                <label class="font-semibold block mb-2">Código</label>
                                <input pInputText type="text" class="w-full" [ngModel]="codigo()" (ngModelChange)="codigo.set($event)" [disabled]="camposDesabilitados || !modoNovo()" placeholder="Ex.: A26" />
                            </div>
                            <div class="field">
                                <label class="font-semibold block mb-2">Descrição</label>
                                <input pInputText type="text" class="w-full" [ngModel]="descricao()" (ngModelChange)="descricao.set($event)" [disabled]="camposDesabilitados" placeholder="Descrição do débito" />
                            </div>
                            <div class="field">
                                <label class="font-semibold block mb-2">Multa</label>
                                <div class="percentual-input-wrap">
                                    <p-inputNumber [ngModel]="multaPercentual()" (ngModelChange)="multaPercentual.set($event)" [disabled]="camposDesabilitados" [min]="0" [max]="100" class="flex-1" />
                                    <span class="percentual-suffix">%</span>
                                </div>
                            </div>
                            <div class="field">
                                <label class="font-semibold block mb-2">Juros Mensal</label>
                                <div class="percentual-input-wrap">
                                    <p-inputNumber [ngModel]="jurosMensalPercentual()" (ngModelChange)="jurosMensalPercentual.set($event)" [disabled]="camposDesabilitados" [min]="0" [max]="100" class="flex-1" />
                                    <span class="percentual-suffix">% ao mês</span>
                                </div>
                            </div>
                            <div class="field">
                                <p-selectbutton
                                    [options]="tiposDebito"
                                    [ngModel]="tipoDebito()"
                                    (ngModelChange)="tipoDebito.set($event)"
                                    optionLabel="label"
                                    optionValue="value"
                                    [disabled]="camposDesabilitados"
                                    [unselectable]="true"
                                    styleClass="tipo-selectbutton p-2 h-15"
                                    fluid
                                ></p-selectbutton>
                            </div>
                        </div>
                    </app-card-content>
                </div>

                <!-- ─ Regras de Cálculo ─ -->
                <div class="card-entrada card-entrada-2">
                    <app-card-content [border]="false" [headerColor]="false" [title]="'Regras de Cálculo'" [subtitle]="'Comportamento do débito'" [icon]="'pi pi-shield'">
                        <div class="flex flex-col gap-2">
                            @for (regra of regrasConfig; track regra.label) {
                                <div class="regra-row">
                                    <span class="regra-label">{{ regra.label }}</span>
                                    <p-toggleswitch [ngModel]="getRegraValue(regra.model)" (ngModelChange)="updateRegra(regra.model, $event)" [disabled]="camposDesabilitados" />
                                </div>
                            }
                        </div>
                    </app-card-content>
                </div>
            </div>

            <!-- ═══════════════════════════════════════════
                 COLUNA DIREITA — Dados
            ═══════════════════════════════════════════ -->
            <div class="coluna-conteudo">
                <!-- ─ Cronograma de Descontos ─ -->
                <div class="card-entrada card-entrada-1">
                    <app-card-content [border]="false" [headerColor]="false" [title]="'Cronograma de Descontos'" [subtitle]="'Datas-limite e percentuais'" [icon]="'pi pi-calendar'">
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                            @for (desc of descontos(); track desc.label; let i = $index) {
                                <app-card-content [headerColor]="false" [title]="desc.label" [subtitle]="'Configuração de desconto'" [icon]="'pi pi-calendar-clock'">
                                    <div class="flex flex-col gap-2">
                                        <div class="field">
                                            <label class="filtro-label-mini">Data limite</label>
                                            <p-datepicker [(ngModel)]="desc.data" [disabled]="camposDesabilitados" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" styleClass="w-full" />
                                        </div>
                                        <div class="field">
                                            <label class="filtro-label-mini">Percentual</label>
                                            <div class="percentual-input-wrap">
                                                <p-inputNumber [(ngModel)]="desc.percentual" [disabled]="camposDesabilitados" [min]="0" [max]="100" class="flex-1" />
                                                <span class="percentual-suffix">%</span>
                                            </div>
                                        </div>
                                    </div>
                                </app-card-content>
                            }
                        </div>
                    </app-card-content>
                </div>

                <!-- ─ Pessoa Física ─ -->
                <div class="card-entrada card-entrada-2">
                    <app-card-content [border]="false" [headerColor]="false" [title]="'Pessoa Física'" [subtitle]="'Valor, vencimento e parcelamento'" [icon]="'pi pi-id-card'">
                        <div class="config-inline mb-4">
                            <div class="flex items-center gap-2">
                                <span class="filtro-label-mini">Conta PF:</span>
                                <div class="conta-selector">
                                    <div class="conta-codigo-badge" [class.is-set]="pfContaId()" [title]="getFormatConta(pfContaId())">
                                        <i class="pi" [ngClass]="pfContaId() ? 'pi-tag' : 'pi-circle'"></i>
                                        <code class="conta-codigo-value">{{ getFormatConta(pfContaId()) }}</code>
                                    </div>
                                    <div class="conta-selector-btns">
                                        @if (pfContaId() && !camposDesabilitados) {
                                            <p-button icon="pi pi-times" severity="danger" [text]="true" size="small" (click)="limparConta(pfContaId)" pTooltip="Limpar" tooltipPosition="top" />
                                        }
                                        <p-button icon="pi pi-search" [outlined]="true" size="small" [disabled]="camposDesabilitados" (click)="abrirSelecionarConta(pfContaId)" pTooltip="Selecionar conta" tooltipPosition="top" />
                                    </div>
                                </div>
                            </div>
                            <div class="flex items-center gap-2 border-l border-surface-200 dark:border-surface-700 pl-3">
                                <span class="filtro-label-mini">Parcelamento:</span>
                                <p-toggleswitch [ngModel]="pfParcelamento()" (ngModelChange)="pfParcelamento.set($event)" [disabled]="camposDesabilitados" />
                            </div>
                            @if (pfParcelamento()) {
                                <div class="flex items-center gap-2 border-l border-surface-200 dark:border-surface-700 pl-3">
                                    <span class="filtro-label-mini">Data limite:</span>
                                    <p-datepicker [ngModel]="pfDataParcelamento()" (ngModelChange)="pfDataParcelamento.set($event)" [disabled]="camposDesabilitados" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" />
                                </div>
                            }
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div class="field">
                                <label class="font-semibold block mb-2">Valor</label>
                                <p-inputNumber [ngModel]="pfValor()" (ngModelChange)="pfValor.set($event)" [disabled]="camposDesabilitados" mode="currency" currency="BRL" locale="pt-BR" class="w-full" inputStyleClass="w-full" />
                            </div>
                            <div class="field">
                                <label class="font-semibold block mb-2">Desc. 1ª Inscrição</label>
                                <div class="percentual-input-wrap">
                                    <p-inputNumber [ngModel]="pfDescPrimeiraInscricao()" (ngModelChange)="pfDescPrimeiraInscricao.set($event)" [disabled]="camposDesabilitados" [min]="0" [max]="100" class="flex-1" />
                                    <span class="percentual-suffix">%</span>
                                </div>
                            </div>
                            <div class="field">
                                <label class="font-semibold block mb-2">Vencimento</label>
                                <p-datepicker [ngModel]="pfVencimento()" (ngModelChange)="pfVencimento.set($event)" [disabled]="camposDesabilitados" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" styleClass="w-full" />
                            </div>
                        </div>
                    </app-card-content>
                </div>

                <!-- ─ Pessoa Jurídica ─ -->
                <div class="card-entrada card-entrada-3">
                    <app-card-content [border]="false" [headerColor]="false" [title]="'Pessoa Jurídica'" [subtitle]="'Faixas por capital social'" [icon]="'pi pi-building'">
                        <div card-header>
                            <p-button label="Adicionar Faixa" icon="pi pi-plus" severity="primary" [disabled]="camposDesabilitados" (click)="abrirModalNovaFaixa()" [appCan]="roleAnuidadesEditar" />
                        </div>

                        <div class="config-inline mb-4">
                            <div class="flex items-center gap-2">
                                <span class="filtro-label-mini">Conta PJ:</span>
                                <div class="conta-selector">
                                    <div class="conta-codigo-badge" [class.is-set]="pjContaId()" [title]="getFormatConta(pjContaId())">
                                        <i class="pi" [ngClass]="pjContaId() ? 'pi-tag' : 'pi-circle'"></i>
                                        <code class="conta-codigo-value">{{ getFormatConta(pjContaId()) }}</code>
                                    </div>
                                    <div class="conta-selector-btns">
                                        @if (pjContaId() && !camposDesabilitados) {
                                            <p-button icon="pi pi-times" severity="danger" [text]="true" size="small" (click)="limparConta(pjContaId)" pTooltip="Limpar" tooltipPosition="top" />
                                        }
                                        <p-button icon="pi pi-search" [outlined]="true" size="small" [disabled]="camposDesabilitados" (click)="abrirSelecionarConta(pjContaId)" pTooltip="Selecionar conta" tooltipPosition="top" />
                                    </div>
                                </div>
                            </div>
                            <div class="flex items-center gap-2 border-l border-surface-200 dark:border-surface-700 pl-3">
                                <span class="filtro-label-mini">Parcelamento:</span>
                                <p-toggleswitch [ngModel]="pjParcelamento()" (ngModelChange)="pjParcelamento.set($event)" [disabled]="camposDesabilitados" />
                                @if (pjParcelamento()) {
                                    <p-datepicker [ngModel]="pjDataParcelamento()" (ngModelChange)="pjDataParcelamento.set($event)" [disabled]="camposDesabilitados" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" />
                                }
                            </div>
                            <div class="flex items-center gap-2 border-l border-surface-200 dark:border-surface-700 pl-3">
                                <span class="filtro-label-mini">Vencimento:</span>
                                <p-datepicker [ngModel]="pjVencimento()" (ngModelChange)="pjVencimento.set($event)" [disabled]="camposDesabilitados" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" />
                            </div>
                            <div class="flex items-center gap-2 border-l border-surface-200 dark:border-surface-700 pl-3">
                                <span class="filtro-label-mini">Desc. Consultório:</span>
                                <div class="percentual-input-wrap">
                                    <p-inputNumber [ngModel]="pjDescConsultorio()" (ngModelChange)="pjDescConsultorio.set($event)" [disabled]="camposDesabilitados" [min]="0" [max]="100" inputStyleClass="w-16 text-center" />
                                    <span class="percentual-suffix">%</span>
                                </div>
                            </div>
                        </div>

                        <!-- Tabela de faixas — padrão grid-pagamento (leitura; edição via modal) -->
                        <p-table [value]="pjFaixas()" [tableStyle]="{ 'min-width': '36rem' }" [rowHover]="true" stripedRows>
                            <ng-template pTemplate="header">
                                <tr>
                                    <th class="w-20 text-center"><strong>Faixa</strong></th>
                                    <th class="text-right"><strong>Capital Inicial</strong></th>
                                    <th class="text-right"><strong>Capital Final</strong></th>
                                    <th class="text-right"><strong>Valor Base</strong></th>
                                    <th class="w-24 text-center"><strong>Ações</strong></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item let-index="rowIndex">
                                <tr>
                                    <td class="text-center">
                                        <p-badge [value]="item.faixa" badgeSize="large" severity="secondary" />
                                    </td>
                                    <td class="text-right">
                                        <span class="text-sm text-surface-600 dark:text-surface-400 tabular-nums">{{ item.inicial != null ? (item.inicial | currency: 'BRL' : 'symbol' : '1.2-2') : '—' }}</span>
                                    </td>
                                    <td class="text-right">
                                        <span class="text-sm text-surface-600 dark:text-surface-400 tabular-nums">{{ item.final != null ? (item.final | currency: 'BRL' : 'symbol' : '1.2-2') : '—' }}</span>
                                    </td>
                                    <td class="text-right">
                                        @if (item.valor != null) {
                                            <p-badge value="{{ item.valor | currency: 'BRL' : 'symbol' : '1.2-2' }}" badgeSize="xlarge" class="p-badge-info" />
                                        } @else {
                                            <span class="text-surface-300 dark:text-surface-600 text-xs italic">—</span>
                                        }
                                    </td>
                                    <td class="text-center">
                                        <div class="flex justify-center gap-1">
                                            <p-button icon="pi pi-pencil" [text]="true" [rounded]="true" size="small" [disabled]="camposDesabilitados" (click)="abrirModalEditarFaixa(index)" pTooltip="Editar" [appCan]="roleAnuidadesEditar" />
                                            <p-button icon="pi pi-trash" [text]="true" [rounded]="true" size="small" severity="danger" [disabled]="camposDesabilitados" (click)="removerFaixa(index)" pTooltip="Remover" [appCan]="roleAnuidadesEditar" />
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="5" style="text-align: center; padding: 2.5rem 1rem">
                                        <i class="pi pi-inbox" style="font-size: 2rem; opacity: 0.3; display: block; margin-bottom: 0.5rem"></i>
                                        Nenhuma faixa cadastrada.
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="footer">
                                <tr class="custom-table-footer">
                                    <td colspan="5">
                                        <strong>Total de Faixas: {{ pjFaixas().length }}</strong>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </app-card-content>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Modal: Faixa PJ -->
<p-dialog
    appDialogoPadrao="pi pi-wallet"
    descricao="Faixa de valor da anuidade."
    [header]="faixaEmEdicaoIndex() === null ? 'Nova Faixa' : 'Editar Faixa ' + (faixaEmEdicaoIndex()! + 1)"
    [visible]="modalFaixaAberto()"
    (visibleChange)="modalFaixaAberto.set($event)"
    [style]="{ width: '420px', maxWidth: '95vw' }"
    [closeOnEscape]="true"
>
    <div class="flex flex-col gap-4 pt-1">
        <div class="field">
            <label class="font-semibold block mb-2">Capital Inicial</label>
            <p-inputNumber [ngModel]="faixaFormInicial()" (ngModelChange)="faixaFormInicial.set($event)" mode="currency" currency="BRL" locale="pt-BR" class="w-full" inputStyleClass="w-full" />
        </div>
        <div class="field">
            <label class="font-semibold block mb-2">Capital Final</label>
            <p-inputNumber [ngModel]="faixaFormFinal()" (ngModelChange)="faixaFormFinal.set($event)" mode="currency" currency="BRL" locale="pt-BR" class="w-full" inputStyleClass="w-full" />
        </div>
        <div class="field">
            <label class="font-semibold block mb-2">Valor Base</label>
            <p-inputNumber [ngModel]="faixaFormValor()" (ngModelChange)="faixaFormValor.set($event)" mode="currency" currency="BRL" locale="pt-BR" class="w-full" inputStyleClass="w-full" />
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancelar" severity="secondary" [outlined]="true" (click)="modalFaixaAberto.set(false)" />
        <p-button [label]="faixaEmEdicaoIndex() === null ? 'Adicionar' : 'Salvar'" icon="pi pi-check" (click)="confirmarFaixa()" [appCan]="roleAnuidadesEditar" />
    </ng-template>
</p-dialog>

<!-- ═══ Modal: Plano de Contas (compartilhado) ═══ -->
<app-seleciona-conta-contabil (contaSelecionada)="onContaSelecionada($event)" />
